import { GetPostsStore, getPostsUseCase } from "../../shared/useCases/posts/getPostsUseCase";

const getPostsHomeUseCase = (store: GetPostsStore) =>
getPostsUseCase(store)

export { getPostsHomeUseCase }; 